import React from 'react'
import { Button } from 'react-bootstrap'
import { Trash } from 'react-bootstrap-icons'
import useConfirmationDialog from '../../../hooks/use-confirmation-dialog'
import useToasts from '../../../hooks/use-toasts'
import useLearningResourceMutations from '../../../hooks/use-learning-resource-mutations'
import BusyModal from '../../modals/busy'

const LearningResourceDeleteButton = ({
    resource = {}
}) => {

    const {
        toastError,
        toastSuccess,
    } = useToasts({
        successMessage: 'Learning Resource Deleted!',
        errorMessage: 'Unable to delete resource.'
    })

    const {
        isDeleting,
        deleteResource,
    } = useLearningResourceMutations({
        onSuccess: toastSuccess,
        onError: toastError,
    })

    const {
        showConfirmation
    } = useConfirmationDialog({
        title: 'Are you sure?',
        description: 'You cannot undo this action.',
        onConfirm: () => deleteResource(resource.id),
    })

    if (isDeleting) {
        return (
            <BusyModal title='Deleting resource...' centered />
        )
    }

    return (
        <Button
            variant='link'
            title='Delete'
            onClick={() => showConfirmation()}
        >
            <Trash />
        </Button>
    )

}

export default LearningResourceDeleteButton